import { Badge, Button, Card, Center, Collapse, Group, Image, Loader, Stack, Text, UnstyledButton } from '@mantine/core'
import { IconChevronDown, IconChevronUp, IconMessageCircle } from '@tabler/icons-react'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { useState } from 'react'
import { useWargaLaporan } from '../../../../hooks/useApi'

export const Route = createFileRoute('/desa/$slug/warga/laporan')({
  component: WargaLaporanPage,
})

function WargaLaporanPage() {
  const { data: laporan, isLoading } = useWargaLaporan()
  const params = useParams({ strict: false }) as { slug?: string }
  const slug = params.slug ?? ''
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <Center py="xl">
        <Loader />
      </Center>
    )
  }

  return (
    <Stack gap="md">
      {!laporan?.length ? (
        <Stack align="center" py="xl" gap="sm">
          <Text c="dimmed" ta="center">
            Belum ada laporan. Sampaikan masalah melalui chat AI desa.
          </Text>
          <Button
            variant="light"
            color="teal"
            size="sm"
            leftSection={<IconMessageCircle size={16} />}
            onClick={() => navigate({ to: `/desa/${slug}/warga/chat` as any })}
          >
            Chat dengan AI Desa
          </Button>
        </Stack>
      ) : (
        <Stack gap="sm">
          {laporan.map((l: any) => (
            <LaporanCard key={l.id} laporan={l} />
          ))}
        </Stack>
      )}
    </Stack>
  )
}

function LaporanCard({ laporan }: { laporan: any }) {
  const [opened, setOpened] = useState(false)
  const fotos = Array.isArray(laporan.foto_urls) ? laporan.foto_urls : []

  const colorMap: Record<string, string> = {
    baru: 'yellow',
    diterima: 'blue',
    dikerjakan: 'blue',
    selesai: 'green',
    ditolak: 'red',
    dieskalasi: 'orange',
    kadaluarsa: 'gray',
  }

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <UnstyledButton onClick={() => setOpened((o) => !o)} w="100%">
        <Group justify="space-between">
          <div>
            <Group gap="xs">
              <Text fw={600} size="sm">
                {laporan.kategori}
              </Text>
              {laporan.sub_kategori && (
                <Text size="xs" c="dimmed">
                  · {laporan.sub_kategori}
                </Text>
              )}
            </Group>
            <Text size="xs" c="dimmed">
              {new Date(laporan.created_at).toLocaleDateString('id-ID', {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
              })}
            </Text>
          </div>
          <Group gap="xs">
            <Badge color={colorMap[laporan.status] ?? 'gray'} variant="light" size="sm">
              {laporan.status}
            </Badge>
            {opened ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
          </Group>
        </Group>
      </UnstyledButton>

      <Collapse in={opened}>
        <Stack gap="sm" mt="sm">
          <Text size="sm">{laporan.deskripsi}</Text>
          {laporan.lokasi && (
            <Text size="xs" c="dimmed">
              Lokasi: {laporan.lokasi}
            </Text>
          )}
          {fotos.length > 0 && (
            <Group gap="xs">
              {fotos.map((url: string) => (
                <Image key={url} src={url} w={80} h={80} radius="sm" fit="cover" />
              ))}
            </Group>
          )}
        </Stack>
      </Collapse>
    </Card>
  )
}
